const { APP_DOMAIN } = Config;

import React from "react";
import { useTranslation } from "react-i18next";
import { toElementProps } from "../../Element.js";

export function CopyrightStyles(params = {}) {
    const { MobileBreakpoint } = params;

    return {
        "& .copyright": {
            // "& .official-website-link": {
            //     gridArea: "official-website-link",
            // },

            display: "grid",

            "& .created-with": {
                // paddingTop: "8px",
                fontSize: "12px",
                color: "#999999",

                "& a": {
                    fontSize: "12px",
                    color: "#999999",
                },
            },

            // gridAreaTemplate: "copyright-text official-website-link created-with",

            [MobileBreakpoint]: {
                textAlign: "center",

                "& .official-website-link": {
                    marginTop: "20px",
                },

                "& .created-with": {
                    paddingTop: "20px",
                    fontSize: "16px",

                    "& a": {
                        fontSize: "20px",
                    },
                },

                // "& .copyright-text": {
                //     gridArea: "copyright-text",
                // },
                // "& .created-with": {
                //     gridArea: "created-with",
                // },
            },
        },
    };
}

export default function Copyright(props) {
    const { t } = useTranslation();
    const { dateCreated, hideCopyright, OfficialWebsiteLink, ProductName, BusinessName, ProductType } = props.variables;
    const startYear = new Date(dateCreated).getFullYear();
    const currentYear = new Date().getFullYear();

    let owl = null;
    {
        const { text, url } = OfficialWebsiteLink || {};
        if (url?.trim?.()) {
            owl = { text: text?.trim?.() || t("OfficialWebsite"), url };
        }
    }

    const elProps = toElementProps(props, { className: ["copyright"] });
    return (
        <div {...elProps}>
            <div className="copyright-text">
                {ProductType === "ecommerce" ? BusinessName : ProductName || "Lorem Ipsum"} &copy;
                <br />
                {startYear}
                {currentYear > startYear ? ` - ${currentYear}` : ""}
            </div>

            {owl && (
                <div className="official-website-link">
                    <a href={owl.url} target="_blank" aria-label={t("AreaLabelOfficialWebsiteLink")}>
                        {owl.text}
                    </a>
                </div>
            )}

            {!hideCopyright && (
                <div className="created-with">
                    {t("CreatedWith")}
                    <br />
                    <a href={`https://${APP_DOMAIN}`} target="_blank">
                        {APP_DOMAIN}
                    </a>
                </div>
            )}
        </div>
    );
}
